/**
 * @generated SignedSource<<5152123c5deccf99b1d648d9eba4f49d>>
 * @relayHash 494d8258faf52b56ead95e20e76dd5f0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 61c7c3c454dc6822fea33b1b6d5c9002b0be0f4002aa1362d23caf71e7dba486

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraSoftwareFormBuilderAppQuery } from './JiraSoftwareFormBuilderAppQuery.graphql';

const node: PreloadableConcreteRequest<JiraSoftwareFormBuilderAppQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "61c7c3c454dc6822fea33b1b6d5c9002b0be0f4002aa1362d23caf71e7dba486",
    "metadata": {},
    "name": "JiraSoftwareFormBuilderAppQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
